import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { IconX } from '@tabler/icons-react';

const HideSmartCardDialog = ({ open, onClose, handleHideSmartCard, selectedSmartCardId }) => {
const [isSubmitting, setIsSubmitting] = React.useState(false);
const handleConfirm = async() => {
    setIsSubmitting(true);
    try{
        await handleHideSmartCard();
    }catch(error){
        console.error("Error hiding smart card: ", error);
    }finally{
        setIsSubmitting(false);
        onClose();
    }   
}
return (
    <Dialog 
      open={open} 
      onClose={isSubmitting ? null : onClose}
      PaperProps={{
        sx: {
          borderRadius: '24px', 
          padding: { xs: '24px 16px', sm: '32px' },
          width: '564px',
          maxWidth: '100%',
          boxShadow: '0 22px 22px 0 rgba(0, 0, 0, 0.12), 0 7px 7px 0 rgba(0, 0, 0, 0.08)',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          margin: { xs: 2, sm: 4 }
        }
      }}
    >
      {/* Header with Title and Close Icon */}
      <DialogTitle sx={{p:0, mb:0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography  
        sx={{
          p:0, 
          fontWeight: 600,
          fontStyle: "normal", 
          fontFamily: "Rubik", 
          fontSize: '20px', 
          color: '#000'
          }}
        >
          Hide Smart Card
        </Typography>
        {!isSubmitting && 
          <IconButton 
            onClick={onClose}
            sx={{ 
              p: 0,
              color: '#001A47',
              display: { xs: 'none', sm: 'inline-flex' }
            }}
            aria-label="close dialog"
          >
            <IconX size={24} />
          </IconButton>
        }
      </DialogTitle>

      {/* Main Content Body */}
      <DialogContent sx={{ p: 0, mb: 1 }}>
       <Typography 
       sx={{ 
        color: '#000000', 
        fontSize: '16px', 
        lineHeight: '24px',
        fontFamily: 'Noto Sans', 
        fontWeight: 400, 
        fontStyle: 'normal' 
        }}
        >
          This will hide{' '}
          <Box 
          component="span" 
          sx={{ 
            fontWeight: 600 
            }}
            >
            "{selectedSmartCardId?.title}"
          </Box>{' '}
          from your Smart Cards view. You can restore it anytime from the Reports page under Smart Cards.
        </Typography>
      </DialogContent>

      {/* Action Buttons */}
      <DialogActions disableSpacing sx={{ p: 0, gap: 2, justifyContent: { xs: 'flex-start', sm: 'flex-end'} }}>
        <Button 
          onClick={onClose}
          disabled={isSubmitting}
          variant="outlined"
          sx={{ 
            borderRadius: '24px', 
            height: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: 'auto', sm: '84px' },
            flex: { xs: 'auto', sm: 'none' },
            textTransform: 'none', 
            padding: { xs: '8px 12px', sm: '0 16px' },
            fontWeight: 600,
            borderColor: '#2F54A5',
            textAlign: "center",
            color: '#2F54A5', 
            fontSize: { xs: '14px', sm: '16px' },
            lineHeight: "24px", 
            fontFamily: "Noto Sans", 
            fontStyle: "normal" 
          }}
        >
         <Box
         component="span" 
         sx={{ 
          height: '11px', 
          width: '52px', 
          textAlign: 'center',
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
          }}
        >
            Cancel
          </Box>
        </Button>
        <Button 
          onClick={handleConfirm}
          disabled={isSubmitting}
          disableElevation
          sx={{ 
            borderRadius: '24px', 
            height: '44px',
            width: { xs: 'auto', sm: '160px' },
            flex: { xs: 'auto', sm: 'none' },
            textTransform: 'none', 
            padding: { xs: '8px 12px', sm: '0 16px' },
            backgroundColor: '#2F54A5',
            '&:hover': { backgroundColor: '#344e91' }
          }}
        >
        <Typography 
        sx={{
          height: '11px',
          width: '128px',
          textAlign: 'center',
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' ,
          fontWeight: 600,
          textWrap: "nowrap",
          color: '#ffffff', 
          fontSize: { xs: '14px', sm: '16px' }, 
          lineHeight: "24px", 
          fontFamily: "Noto Sans", 
          fontStyle: "normal",
          }}
        >
            {isSubmitting ? 'Hiding...' : 'Hide Smart Card'}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HideSmartCardDialog;
